import React from "react";
import {format} from "date-fns";
import {idempiereDate} from "../../../../res/dataServices/idempiereDate";
import {Button} from "../../../general/input/Button";
import {formatDisplayPrice} from "../../../../res/dataServices/pricing";
import HeaderLink from "./HeaderLink";
import CompactShipment from "./CompactShipment";
import CompactOrder from "./CompactOrder";
import {useNavigate} from "react-router-dom";

const HeaderInvoice = ({invoice, orders, shipments}) => {

    const navigate = useNavigate();
    const onSeeFullDetails = () => {
        navigate("/account/ordering/invoices/" + invoice.id);
    }

    const jsInvoiced = idempiereDate.getDate(invoice.DateInvoiced);
    const issued = format(jsInvoiced, "dd/MM/yy");

    const displayPrice=formatDisplayPrice(invoice.GrandTotal);
    const invoiceStatus = null;

    const isPayed = false;

    return (
        <div className="tile">
            <div className="tile-header account-tile-header-container">
                <div className="account-tile-header-detail">
                    <p className="account-tile-h">Invoice</p>
                    <p className="account-tile-h">Issued</p>
                    <p className="account-tile-b" style={{color: "var(--primary)"}}>{invoice.DocumentNo}</p>
                    <p className="account-tile-b">{issued}</p>
                </div>
                <HeaderLink txt="Order(s)">
                    {(orders && orders.length > 0) ?
                        orders.map((e,i) =>
                            <CompactOrder key={i} order={e} />
                        )
                        : <p className="account-link-empty">There are no invoices linked to this order</p>
                    }
                </HeaderLink>
                <HeaderLink txt="Shipment(s)">
                    {(shipments && shipments.length) > 0 ?
                        shipments.map((e,i) =>
                            <CompactShipment key={i} shipment={e} />
                        )
                        : <p className="account-link-empty">There are no invoices linked to this order</p>
                    }
                </HeaderLink>
            </div>
            <div className="account-tile-body">
                <div className="account-tile-content">
                    <p className="account-tile-content-h">Status</p>
                    <p className="account-tile-content-b">{invoiceStatus}</p>
                    <p className="account-tile-content-h">Total</p>
                    <p className="account-tile-content-b">{displayPrice}</p>
                </div>
                <div className="account-tile-action">
                    {!isPayed && <Button>Make Payment</Button>}
                    <Button onClick={onSeeFullDetails}>See Full Details</Button>
                </div>
            </div>
        </div>
    )
}

export default HeaderInvoice;